export default __webpack_public_path__ + "static/media/MySketchbook.cbf290f8.svg";